export default {
  placeholder: 'Vybrať úroveň hierarchie zariadenia',
};
